import axios from 'axios';
import { ElMessage } from "element-plus"

export const post = (url : string, data = {}, header = '') => {
  const token = ''

  let headers = {}
  if (header === '') {
    headers = {
      token
    }
  } else {
    headers = {
      token,
      'Content-Type': 'multipart/form-data'
    }
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data, {
      // baseURL: process.env.VUE_APP_BASE_API,
      baseURL: process.env.VUE_APP_BASE_API,
      headers,
      timeout: 50000
    }).then((response) => {
      if (response.status === 200) {
        if (response.data.errorCode === 0) {
          resolve(response.data)
        } else {
          ElMessage.error(response.data.errorInfo)
          reject(response.data.errorInfo)
        }
      } else {
        console.log(response,"error")
        ElMessage.error('网络错误,请稍后重试')
        reject(response)
      }
    }, () => {
      ElMessage.error('网络错误,请稍后重试')
      reject('网络错误,请稍后重试')
    })
  })
}
